import React, { useState } from "react";
import { useAsyncDebounce } from "react-table";
import { icons } from "../../assets/icons";

export const GlobalSearch = ({ filter, setFilter }) => {
  const [value, setValue] = useState(filter);
  const onChange = useAsyncDebounce((value) => {
    setFilter(value || undefined);
  }, 500);
  return (
    <div className="mb-3 flex border pr-3.5 pl-3 pt-3.5 pb-3.5 rounded-lg text-2xl text-lightgray">
      <div class="input-group">
        <span class="input-group-text" id="inputGroup-sizing-default text-gray-500 font-size-lg" style={{color: 'rgb(55 65 81)'}}>
          Search: {" "}
        </span>
        <input
          value={value || ""}
          onChange={(e) => {
            setValue(e.target.value);
            onChange(e.target.value);
          }}
          type="text"
          class="form-control font-size-small focus:outline-none"
          aria-label="Sizing example input"
          aria-describedby="inputGroup-sizing-default"
        />
      </div>
      <img
        src={icons.searchIcon}
        alt="search icon"
        className="w-[1.2rem]"
      />
    </div>
  );
};